import {
  SET_PREVIEW,
  SET_LAST_SELECTED_ENTITY_TYPES,
  SET_LOADING,
  SET_ERROR,
  SET_BITRIX_AUTH,
  SET_IS_BITRIX,
  SET_BITRIX_LINKED,
  SET_BITRIX_CONNECTION_VALID,
} from "./mutation-types";
import { RESET } from "../../mutation-types";

const getDefaultState = () => ({
  preview: [],
  lastSelectedEntityTypes: [],
  loading: false,
  error: null,
  bitrixAuth: null,
  isBitrix: false,
  isBitrixLinked: false,
  isBitrixConnectionValid: true,
});

const mutations = {
  [SET_PREVIEW]: (state, payload) => {
    state.preview = payload;
  },

  [SET_LAST_SELECTED_ENTITY_TYPES]: (state, payload) => {
    state.lastSelectedEntityTypes = payload;
  },

  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },

  [SET_ERROR]: (state, payload) => {
    state.error = payload;
  },

  [RESET]: (state) => {
    Object.assign(state, getDefaultState());
  },
  [SET_BITRIX_AUTH]: (state, payload) => {
    state.bitrixAuth = payload;
  },

  [SET_IS_BITRIX]: (state, payload) => {
    state.isBitrix = payload;
  },

  [SET_BITRIX_LINKED]: (state, payload) => {
    state.isBitrixLinked = payload;
  },

  [SET_BITRIX_CONNECTION_VALID]: (state, payload) => {
    state.isBitrixConnectionValid = payload;
  },
};

export default mutations;
